import React from 'react';
import { Column } from '../../components/column';
import { Section } from '../../components/section';
import { Spacer } from '../../components/spacer';
import { shorthand } from '../../utils/css-utils';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { itemGridColumn, itemGridSpacer } from './css-classes';
import { ItemButton } from './item-button';
import { ItemDescription } from './item-description';
import { ItemImage } from './item-image';
import { ItemPrice } from './item-price';
import { ItemTitle } from './item-title';
export const SectionItemGridVertical = (props) => {
    const { section, cssClass, isRtl, experiments } = props;
    const { innerPadding, spacerHeight, leftColumnPadding, rightColumnPadding } = section;
    return (React.createElement(React.Fragment, null, section.items.map((p, idx) => (React.createElement(Section, { key: p.id, backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(section.outerPadding) },
        React.createElement(Column, { padding: innerPadding
                ? `${idx === 0 ? innerPadding.top : spacerHeight}px ${isRtl ? leftColumnPadding : rightColumnPadding} ${idx === section.items.length - 1
                    ? innerPadding.bottom
                    : spacerHeight}px ${innerPadding.left}px`
                : '', cssClass: `${itemGridColumn} ${mobileFullWidthColumnClassName}`, width: section.leftColumnWidth },
            React.createElement(ItemImage, { item: p, spaceForColumn: section.spaceForColumn })),
        React.createElement(Column, { padding: innerPadding
                ? `${idx === 0 ? innerPadding.top : spacerHeight}px ${innerPadding.right}px ${idx === section.items.length - 1
                    ? innerPadding.bottom
                    : spacerHeight}px ${isRtl ? rightColumnPadding : leftColumnPadding}`
                : '', cssClass: `${itemGridColumn} ${mobileFullWidthColumnClassName}`, width: section.rightColumnWidth },
            React.createElement(ItemTitle, { section: section, item: p }),
            section.show?.title !== false &&
                section.show?.description !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
            React.createElement(ItemDescription, { section: section, item: p }),
            section.show?.price !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
            React.createElement(ItemPrice, { section: section, item: p }),
            section.show?.button !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
            React.createElement(ItemButton, { section: section, item: p, experiments: experiments })))))));
};
//# sourceMappingURL=section-item-grid-vertical.js.map